import React, { Suspense } from 'react'

import { LogoLoading } from "../components/Loading";
import AdminRoutes from "./AdminRoutes"
import DoctorRoutes from "./DoctorRoutes"
import ResearcherRoutes from "./ResearcherRoutes"
import AuthRoutes from "./AuthRoutes"
import { useSelector } from 'react-redux';
import { DOCTOR_ROLE, SUPER_ADMIN_ROLE, SUB_DOCTOR_ROLE, RESEARCHER_ROLE } from '../constants';
import BaseApi from '../components/BaseApi';
// import Sidebar from '../components/Sidebar';

const BaseRoutes = () => {
  const user = useSelector(state => state.user);

  return (
    <Suspense fallback={<LogoLoading />}>
      {
        user && user.role === SUPER_ADMIN_ROLE ?
          <AdminRoutes />
          : user && user.role === RESEARCHER_ROLE ?
            <ResearcherRoutes />
          : user && (user.role === DOCTOR_ROLE || user.role === SUB_DOCTOR_ROLE) ?
            <BaseApi>
              <DoctorRoutes />
            </BaseApi>
            :
            <AuthRoutes />
      }
    </Suspense>
  )
}

export default BaseRoutes